import { CustomersDto } from '@/src/models/CustomersDto';

export class AddressDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  regionDepth1: string;
  regionDepth2: string;
  regionDepth3: string;
  zipCode: string;
  country: string;
  detail: string;
  street: string;
  zibun: string;
  isBaseAddress: boolean;
  addressName: string;
  senderName: string;
  phone: string;
  customer: CustomersDto;
}
